class Customer.OperatorGroup extends Backbone.Model
  defaults:
    id: 0
    account_setting_id: 0
    name: ''
    user_ids: []
    created_at: '1900-01-01T00:00:00-00:00'
    updated_at: '1900-01-01T00:00:00-00:00'

class Customer.OperatorGroupCollection extends Backbone.Collection
  model: Customer.OperatorGroup
  url: '/customer_operator_groups'
